import { render, staticRenderFns } from "./standarProcedures.vue?vue&type=template&id=6448f68a&scoped=true&"
import script from "./standarProcedures.vue?vue&type=script&lang=js&"
export * from "./standarProcedures.vue?vue&type=script&lang=js&"
import style0 from "./standarProcedures.vue?vue&type=style&index=0&id=6448f68a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448f68a",
  null
  
)

component.options.__file = "standarProcedures.vue"
export default component.exports